<div
  class="toggle-wrapper"
  [ngClass]="{
    'pointer-events-none opacity-75 !cursor-default': disabled,
    'flex-row-reverse': isReversed,
    'justify-start': position === 'left',
    'justify-end': position === 'right',
    'justify-center': position === 'center',
    'justify-between': position === 'space-between',
  }"
>
  <div
    *ngIf="textHelper"
    class="toggle-wrapper__helper text-mg-primary flex items-center justify-center gap-2"
  >
    <button (click)="openWarningModal()">
      <mg-icons class="h-6 w-6" [name]="'bold-info-circle'"></mg-icons>
    </button>
    <p class="body-bold text-mg-primary">{{ textHelper }}</p>
  </div>
  <button
    [id]="id + '-toggle'"
    class="toggle-wrapper__container"
    (click)="toggle()"
    aria-label="toggle"
    [ngClass]="{
      'bg-mg-success': value || active,
      'bg-mg-neutral-light': !value || !active,
    }"
  >
    <div
      class="toggle-wrapper__container__button"
      [ngClass]="{
        'translate-x-[18px]': value || active,
        'translate-x-[4px]': !value || !active,
      }"
    ></div>
  </button>
  <div class="flex items-center gap-2" *ngIf="label || badgeText()">
    <p class="toggle-wrapper__text" *ngIf="label">
      {{ label }}
    </p>
    @if (badgeText()) {
      <button
        type="button"
        class="flex h-6 min-h-6 p-2 justify-center items-center gap-2 rounded-xl bg-mg-primary cursor-pointer"
        (click)="onBadgeClick($event)"
      >
        <span
          class="text-mg-white text-center text-xs leading-[120%] font-bold"
          >{{ badgeText() }}</span
        >
      </button>
    }
  </div>
  <ng-content></ng-content>
</div>
